export default "__VITE_ASSET__tesR$ndD__"